export * from './industry-type-add-edit.component';
export * from './industry-type-list.component';